import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TransferStatus } from '../../../core/models/app.models';

@Component({
  selector: 'app-transfer-status-select',
  template: `
    <p-dropdown [options]="options" 
                [(ngModel)]="value" 
                [showClear]="showClear" 
                [placeholder]="placeholder" 
                [styleClass]="styleClass"
                (onChange)="onChanged($event.value)"
                optionLabel="label" 
                optionValue="value">
      <ng-template let-option pTemplate="item">
        <div class="flex align-items-center gap-2">
          <i [class]="option.icon" [style.color]="option.color"></i>
          <span>{{ option.label }}</span>
        </div>
      </ng-template>
    </p-dropdown>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TransferStatusSelectComponent),
      multi: true
    }
  ]
})
export class TransferStatusSelectComponent implements ControlValueAccessor {
  @Input() placeholder: string = 'Vyberte stav';
  @Input() showClear: boolean = true;
  @Input() styleClass: string = '';

  options = [
    { label: 'K vyřešení', value: TransferStatus.ToResolve, icon: 'pi pi-clock', color: '#3B82F6' },
    { label: 'Čeká se na protistranu', value: TransferStatus.PendingOtherSide, icon: 'pi pi-user', color: '#F59E0B' },
    { label: 'Čeká se na podpisy', value: TransferStatus.PendingOurSignatures, icon: 'pi pi-pencil', color: '#A855F7' },
    { label: 'Potvrzení FAČR', value: TransferStatus.PendingFacrConfirmation, icon: 'pi pi-external-link', color: '#6366F1' },
    { label: 'Vyřešeno', value: TransferStatus.Resolved, icon: 'pi pi-check-circle', color: '#22C55E' },
    { label: 'Stornováno', value: TransferStatus.Cancelled, icon: 'pi pi-times-circle', color: '#EF4444' }
  ];

  _value: any;
  get value() { return this._value; }
  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void { this._value = value; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }

  onChanged(val: any) {
    this.value = val;
  }
}
